import axios from 'axios';
import {logServiceEndpoint} from '../../utils/constants/EndPoint';

export function logService(logInfo, appConfig) {

  const apiUrl = appConfig?.exrServiceApi;
  return axios.post(apiUrl + logServiceEndpoint, logInfo);
}
